<script>
  import { configStore } from "./stores/config.store";
  import { ping } from "./api/user.js";
  import { onMount } from "svelte";
  import Login from "./modules/User/Login.svelte";
  import Dashboard from "./modules/Base/Dashboard.svelte";
  import { logout } from "./api/user";
  import { hooksStore } from "./stores/hooks.store.js";
  import {
    userStore,
    currentUserId,
    apiStoreSaveTimer,
    ulozStavDoApi,
  } from "./stores/user.store";

  const title = $configStore.titulka || __myapp.env.APP_TITLE;
  let jePrihlaseny = false;
  let nacitavanie = true;

  // odhlasenie uzivatela
  // volanie v ./helpers/api.js
  hooksStore.addAction("odhlasitUzivatela", "App", async () => {
    await logout();
    jePrihlaseny = false;
  });

  hooksStore.addAction("zrusitIntervalUkladaniaStavu", "App", () => {
    clearInterval($apiStoreSaveTimer);
    $apiStoreSaveTimer = false;
  });

  onMount(async () => {
    // zistim obycajnym volanim, ci je uzivatel prihlaseny
    const prihlaseny = await ping();
    if (prihlaseny) {
      // ak je prihlaseny, treba nastavit stav
      const stav = await userStore.initStoredUser($currentUserId);
      nacitavanie = false;
      // ak je uspesne nastaveny stav, tak povazujem uzivatela za prihlaseneho
      if (stav) {
        jePrihlaseny = true;
        // kazdych 5min sa posle stav do api
        $apiStoreSaveTimer = setInterval(async () => {
          const stav = userStore.getUser();
          if (stav) {
            ulozStavDoApi(stav);
          }
        }, 1000 * 60 * 50);
      }
    } else {
      nacitavanie = false;
      // ak uzivatel nie je prihlaseny a zobrazi sa formular,
      // nastavim kurzor na prihlasovacie meno
      hooksStore.doAction("loginFocus");
    }
  });

  // z konfigu vytvaram styly farieb
  let stylyFarieb = "";
  if ($configStore.farby) {
    for (const farba of $configStore.farby) {
      stylyFarieb += `
        .color__text--${farba.kod} {
          color: #${farba.html_kod};
        }
        .color__bg--${farba.kod} {
          background-color: #${farba.html_kod};
        }
      `;
    }
  }
  // svelte to nevie vlozit, tak to vkladam cez klasicke JS
  document.head.insertAdjacentHTML(
    "beforeend",
    `<style>${stylyFarieb}</style>`
  );
</script>

<svelte:head>
  <title>{title}</title>
</svelte:head>

{#if jePrihlaseny}
  <Dashboard />
{:else}
  <Login bind:jePrihlaseny bind:nacitavanie />
{/if}
